/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\NavLinkStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Thursday, February 16th 2023, 9:57:48 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const NavLinkStyled = styled(NavLink).attrs(props => {return ({
        bgColor: props.bgColor,
        style: props.style,
    })})`
color: white;
padding: 0.7rem 1rem 0.55rem;
border-top-right-radius: 20px;
border-top-left-radius: 20px;
align-content: flex-start;
&:hover{
    background-color: ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
    color:white;
}
`;

export default NavLinkStyled;
